import { render, staticRenderFns } from "./TotalProcessRoom.vue?vue&type=template&id=dabdcea2&"
import script from "./TotalProcessRoom.vue?vue&type=script&lang=js&"
export * from "./TotalProcessRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports